<template>
	<div class="page-faq u-s-p-t-80">
		<div class="container">
			<div class="faq u-s-m-b-50">
				<h1>Terms and conditions for checkout</h1>
				<h1>
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo et dolorem odio
					voluptatibus at aperiam cupiditate quibusdam autem. Rem iure dicta facilis fugit
					at accusamus mollitia perferendis quasi dolorum alias!.
				</h1>
				<p>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id erat sagittis,
					faucibus metus malesuada, eleifend turpis. Mauris semper augue id nisl aliquet,
					a porta lectus mattis. Nulla at tortor augue. In eget enim diam. Donec gravida
					tortor sem, ac fermentum nibh rutrum sit amet. Nulla convallis mauris vitae
					congue consequat. Donec interdum nunc purus, vitae vulputate arcu fringilla
					quis. Vivamus iaculis euismod dui.
				</p>
			</div>
			<div class="u-s-m-b-50">
				<div class="f-a-q u-s-m-b-30">
					<a data-toggle="collapse" href="#faq-1">How can I get discount coupon ?</a>
					<div class="collapse show" id="faq-1">
						<p>
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis
							error incidunt laborum modi nisi odio. Aut dolore earum fugit itaque laborum,
							necessitatibus quos ullam. Dolores ex porro praesentium sequi.
						</p>
					</div>
				</div>
				<div class="f-a-q u-s-m-b-30">
					<a data-toggle="collapse" href="#faq-2"
						>Do I need creat account for buy products ?</a
					>
					<div class="collapse" id="faq-2">
						<p>
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis
							error incidunt laborum modi nisi odio. Aut dolore earum fugit itaque laborum,
							necessitatibus quos ullam. Dolores ex porro praesentium sequi.
						</p>
					</div>
				</div>
				<div class="f-a-q u-s-m-b-30">
					<a data-toggle="collapse" href="#faq-3">How can I track my order ?</a>
					<div class="collapse" id="faq-3">
						<p>
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis
							error incidunt laborum modi nisi odio. Aut dolore earum fugit itaque laborum,
							necessitatibus quos ullam. Dolores ex porro praesentium sequi.
						</p>
					</div>
				</div>
				<div class="f-a-q u-s-m-b-30">
					<a data-toggle="collapse" href="#faq-4"
						>What is the payment security system ?</a
					>
					<div class="collapse" id="faq-4">
						<p>
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis
							error incidunt laborum modi nisi odio. Aut dolore earum fugit itaque laborum,
							necessitatibus quos ullam. Dolores ex porro praesentium sequi.
						</p>
					</div>
				</div>
				<div class="f-a-q u-s-m-b-30">
					<a data-toggle="collapse" href="#faq-5"
						>What policy do you have for product sell ?</a
					>
					<div class="collapse" id="faq-5">
						<p>
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis
							error incidunt laborum modi nisi odio. Aut dolore earum fugit itaque laborum,
							necessitatibus quos ullam. Dolores ex porro praesentium sequi.
						</p>
					</div>
				</div>
				<div class="f-a-q u-s-m-b-30">
					<a data-toggle="collapse" href="#faq-6">How I Return back my product ?</a>
					<div class="collapse" id="faq-6">
						<p>
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis
							error incidunt laborum modi nisi odio. Aut dolore earum fugit itaque laborum,
							necessitatibus quos ullam. Dolores ex porro praesentium sequi.
						</p>
					</div>
				</div>
				<div class="f-a-q u-s-m-b-30">
					<a data-toggle="collapse" href="#faq-7">What Payment Methods are Available ?</a>
					<div class="collapse" id="faq-7">
						<p>
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis
							error incidunt laborum modi nisi odio. Aut dolore earum fugit itaque laborum,
							necessitatibus quos ullam. Dolores ex porro praesentium sequi.
						</p>
					</div>
				</div>
				<div class="f-a-q u-s-m-b-30">
					<a data-toggle="collapse" href="#faq-8"
						>What Shipping Methods are Available ?</a
					>
					<div class="collapse" id="faq-8">
						<p>
							Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda blanditiis
							error incidunt laborum modi nisi odio. Aut dolore earum fugit itaque laborum,
							necessitatibus quos ullam. Dolores ex porro praesentium sequi.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {};
</script>

<style></style>
